import { useEffect, useRef } from "react";
import { useDeleteUserAddress } from "../../api/hooks";
import { COUNTRY_ICONS } from "../../assets/icons";
import { MdDelete, MdEdit } from "react-icons/md";
import { ImSpinner2 } from "react-icons/im"; // spinner icon

export function AddressRow({ address, isEditing, setEditingAddressId }) {
  const editRef = useRef(null);

  const { mutateAsync: deleteAddress, isPending } = useDeleteUserAddress();

  useEffect(() => {
    if (isEditing && editRef.current) {
      editRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isEditing]);

  const handleEditToggle = () => {
    setEditingAddressId(isEditing ? null : address.addressId);
  };

  const handleDelete = async () => {
    try {
      await deleteAddress(address.addressId);
    } catch {
    }
  };

  return (
    <div
      ref={editRef}
      className="group relative p-4 rounded-xl border border-gray-100 bg-white 
                 hover:shadow-md hover:bg-gray-50 transition-all"
    >
      {/* Top row: icon + main info */}
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0">
          {COUNTRY_ICONS[address.country.id]}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-900 truncate">
              {address.name}
            </span>
          </div>
          <span className="text-xs text-gray-500 truncate mt-0.5">
            {address.address1}
            {address.address2 && `, ${address.address2}`}, {address.city},{" "}
            {address.state.name}, {address.country.name} {address.zip}
          </span>
        </div>
      </div>

      {/* Contact info */}
      <div className="mt-3 border-t border-gray-100 pt-3 text-xs text-gray-500 space-y-0.5">
        {address.email && <div className="truncate">{address.email}</div>}
        {address.phone && <div className="truncate">{address.phone}</div>}
      </div>

      {/* Hover actions */}
      <div className="absolute top-3 right-3 flex gap-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          onClick={handleEditToggle}
          className="p-1.5 rounded-md bg-gray-100 hover:bg-blue-50 border border-gray-200 transition"
          disabled={isPending}
        >
          <MdEdit className="h-4 w-4 text-blue-600" />
        </button>
        <button
          onClick={handleDelete}
          className="p-1.5 rounded-md bg-gray-100 hover:bg-red-50 border border-gray-200 transition flex items-center justify-center"
          disabled={isPending}
        >
          {isPending ? (
            <ImSpinner2 className="h-4 w-4 animate-spin text-red-600" />
          ) : (
            <MdDelete className="h-4 w-4 text-red-600" />
          )}
        </button>
      </div>
    </div>
  );
}